import {Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {useGetUserQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER, getUserName} from '@dms/shared';

import {parseDate, suffixTestId, TestIdProps} from 'shared/web';

interface WarehouseAccessLastUpdateProps extends TestIdProps {
  modifiedAt: string;
  modifiedBy: string;
}

export function WarehouseAccessLastUpdate(props: WarehouseAccessLastUpdateProps) {
  const dateTimeFormatter = useDateTimeFormatter();
  const {data: modifiedByUser} = useGetUserQuery({id: props.modifiedBy});

  const updatedBy = getUserName(modifiedByUser) ?? EMPTY_PLACEHOLDER;
  const updatedAt = dateTimeFormatter('dateTimeShort', parseDate(props.modifiedAt));

  return (
    <Text size="small" color="secondary" data-testid={suffixTestId('lastUpdate', props)}>
      {`${i18n.t('general.labels.updatedBy')}: ${updatedBy}, ${i18n.t('general.labels.updatedAt')}: ${updatedAt}`}
    </Text>
  );
}
